var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "featured-categories" },
    [
      _vm.isMobile
        ? [
            _c(
              "flickity",
              {
                ref: "mobileFeaturedCategoriesSlider",
                attrs: { options: _vm.flickityOptions },
              },
              _vm._l(_vm.categories, function (category, index) {
                return _c("featured-categories-tile", {
                  key: index,
                  class: `featured-categories-tile__${index}`,
                  attrs: { index: index, category: category },
                })
              }),
              1
            ),
          ]
        : _vm._l(_vm.categories, function (category, index) {
            return _c("featured-categories-tile", {
              key: index,
              class: `featured-categories-tile__${index + 1}`,
              attrs: { index: index, category: category },
            })
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }